import { colors, colorUtility } from "@itandi/itandi-bb-ui";
import { Chip } from "@itandi/itandi-bb-ui/Chip";
import React from "react";
import type { DealType } from "~/models/Deal";
import type { Subtype } from "~/models/Subtype";

type Props = {
	dealSubtype: Subtype | null;
	dealType: DealType;
};

export function DealTypeChip({ dealType, dealSubtype }: Props) {
	const dealTypeChipProperty = React.useMemo(() => {
		if (dealSubtype !== null) {
			return {
				background: colorUtility(colors["expressive-yellow-dark"]).alpha(0.1),
				label: dealSubtype.name,
				textColor: colors["expressive-yellow-dark"]
			};
		}
		if (dealType === "restoration") {
			return {
				background: colorUtility(colors["product-nsk"]).alpha(0.1),
				label: "原状回復",
				textColor: colors["product-nsk"]
			};
		}
		if (dealType === "repair") {
			return {
				background: colorUtility(colors["product-nsk"]).alpha(0.1),
				label: "修繕",
				textColor: colors["product-nsk"]
			};
		}
		return {
			background: colorUtility(colors["expressive-yellow-dark"]).alpha(0.1),
			label: "その他",
			textColor: colors["expressive-yellow-dark"]
		};
	}, [dealSubtype, dealType]);

	return (
		<Chip
			background={dealTypeChipProperty.background}
			borderColor={null}
			fontWeight="bold"
			label={dealTypeChipProperty.label}
			textColor={dealTypeChipProperty.textColor}
		/>
	);
}
